import { render, staticRenderFns } from "./DocumentManageNumberInputDialog.vue?vue&type=template&id=05c208d4&scoped=true&"
import script from "./DocumentManageNumberInputDialog.vue?vue&type=script&lang=ts&"
export * from "./DocumentManageNumberInputDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentManageNumberInputDialog.vue?vue&type=style&index=0&id=05c208d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c208d4",
  null
  
)

export default component.exports